$background-color: #2e0a52;
$highlight-hover-color: #7d5185;

.keyword-info-display-container {
  position: relative;
}

button.keyword {
  background-color: transparent;
  color: inherit;
  transition: background-color 0.3s ease, cursor 0.3s ease, text-decoration 0.3s ease;
  cursor: pointer;
  margin-bottom: unset;
  padding-bottom: unset;

  &[aria-expanded='true'],
  &[aria-expanded='true']:hover,
  &:hover {
    background-color: $highlight-hover-color;
    border-radius: 5px;
  }
}

.info-box {
  color: black;
}
